




import { defineComponent, ref } from '@vue/composition-api';
import Comp from '@/components/Privacy/Privacy.vue';

export default defineComponent({
  name: 'Privacy',
  components: {
    Comp,
  },
});
